// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__X3ZPl","footer":"Auth_footer__YLah4"};